
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/flip-image",
      function () {
        return require("private-next-pages/flip-image/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/flip-image"])
      });
    }
  